<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("profile.profile") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("profile.profile") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
            <div class="form-group row" v-if="!isResidential">
              <div class="col-md-4">
                <base-input
                  disabled
                  placeholder=""
                  :value="IdentityTypeName"
                  :label="$t('profile.identityType')"
                ></base-input>
              </div>

              <div class="col-md-4">
                <base-input
                  disabled
                  placeholder=""
                  :value="profile.IdentityNumber"
                  :label="$t('profile.identityNumber')"
                ></base-input>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <base-input
                  disabled
                  placeholder=""
                  v-model="profile.Name"
                  :label="$t('profile.name')"
                ></base-input>
              </div>

              <div class="col-md-4">
                <base-input
                  disabled
                  placeholder=""
                  v-model="profile.LName"
                  :label="$t('profile.lname')"
                ></base-input>
              </div>
            </div>

            <div class="form-group row" v-if="!isResidential">
              <div class="col-md-3">
                <base-input
                  disabled
                  placeholder=""
                  v-model="profile.Address"
                  :label="$t('profile.address')"
                ></base-input>
              </div>

              <div class="col-md-3">
                <base-input
                  disabled
                  placeholder=""
                  v-model="profile.SubDistrict"
                  :label="$t('profile.district')"
                ></base-input>
              </div>

              <div class="col-md-3">
                <base-input
                  disabled
                  placeholder=""
                  v-model="profile.District"
                  :label="$t('profile.city')"
                ></base-input>
              </div>

              <div class="col-md-3">
                <base-input
                  disabled
                  placeholder=""
                  v-model="profile.Province"
                  :label="$t('profile.province')"
                ></base-input>
              </div>

              <div class="col-md-3">
                <base-input
                  disabled
                  placeholder=""
                  v-model="profile.Postcode"
                  :label="$t('profile.postcode')"
                ></base-input>
              </div>
            </div>

            <hr />

            <div class="form-group row" v-if="!isResidential">
              <label
                for="example-email-input"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("profile.phone") }}</label
              >
              <div class="col-md-4">
                <base-input
                  autocomplete="off"
                  placeholder=""
                  v-model="phone"
                  v-on:keyup="handleCheckPhone"
                  disabled
                  maxLength="10"
                />
              </div>
            </div>
            <div class="form-group row" v-if="isResidential">
              <label
                for="example-email-input"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("profile.phone") }}</label
              >
              <div class="col-md-4">
                <base-input
                  autocomplete="off"
                  placeholder=""
                  v-model="phone"
                  v-on:keyup="handleCheckPhone"
                  :disabled="refCode != ''"
                  maxLength="10"
                />
                <h5 class="text-red" v-if="!phone_verified_org">
                  {{ $t("unverify") }}
                </h5>
              </div>
              <div class="col-md-6" v-if="!phone_verified && refCode == ''">
                <base-button
                  type="primary"
                  @click="handleGetOTP()"
                  :disabled="IsPhoneValid"
                >
                  {{ $t("auth.requestotp") }}
                </base-button>
                <span
                  class="text-red"
                  v-if="phone_verified_org && !phone_verified"
                >
                  {{ $t("mobile_change") }}
                </span>
              </div>
              <div class="col-md-3" v-if="!phone_verified && refCode != ''">
                {{ $t("auth.requestnewotp", [timerCount]) }}
              </div>
              <div class="col-md-3" v-if="phone_verified">
                <base-button type="green" class="text-green">
                  <i class="fa fa-check"></i>
                  {{ $t("verified") }}
                </base-button>
              </div>
            </div>

            <div
              class="form-group row"
              v-if="isResidential && !phone_verified && refCode != ''"
            >
              <label class="col-md-2 col-form-label form-control-label"
                >OTP</label
              >
              <div class="col-md-4">
                <base-input
                  autocomplete="off"
                  placeholder=""
                  v-model="otpCode"
                  maxLength="6"
                  v-on:keyup="handleCheckOTP"
                />
              </div>
              <div class="col-md-3">
                <base-button type="primary" @click="handleVerifyOTP()">
                  {{ $t("profile.verify") }}
                </base-button>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("profile.email")
              }}</label>
              <div class="col-md-4">
                <base-input
                  autocomplete="off"
                  placeholder=""
                  disabled
                  :value="getUser.Email"
                />
              </div>
              <!-- <div class="col-md-3" v-if="isResidential">
                <base-button type="green" class="text-green">
                  <i class="fa fa-check"></i>
                  {{ $t("verified") }}
                </base-button>
              </div> -->
            </div>

            <!-- <div class="form-group row">
              <div class="offset-md-2 col-md-10">
                <base-button type="primary" @click="handleUpdate()">{{
                  $t("save")
                }}</base-button>
              </div>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

import UserMenu from "@/components/NT/UserMenu";

export default {
  name: "Profile",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    UserMenu
  },
  computed: {
    ...mapGetters({
      getUser: "Auth/getUser",
      isResidential: "Auth/isResidential",
      isEnterpriseUser: "Auth/isEnterpriseUser",
      isEnterpriseAdmin: "Auth/isEnterpriseAdmin",
      isNTBackoffice: "Auth/isNTBackoffice",
      isNTAdmin: "Auth/isNTAdmin"
    }),
    IsPhoneValid() {
      let regExp = /^0[1-9][0-9]{8}$/i;
      return !regExp.test(this.phone);
    },

    IdentityTypeName() {
      switch (this.profile.IdentityType) {
        case 1:
          return this.$t("profile.identity_type_1");
        case 2:
          return this.$t("profile.identity_type_2");
        case 3:
          return this.$t("profile.identity_type_3");
        case 4:
          return this.$t("profile.identity_type_4");
      }
      console.log(this.profile.IdentityType);
      return "";
    }
  },
  data() {
    return {
      timerCount: 0,
      phone: "",
      phone_verified: false,
      phone_verified_org: false,
      refCode: "",
      otpCode: "",
      profile: []
    };
  },
  mounted() {
    this.handleGetProfile();
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            if (this.timerCount == 0) {
              this.refCode = "";
            }
          }, 1000);
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setUser: "Auth/setUser",
      getProfile: "Auth/CustomerGetProfile",
      updateProfile: "Auth/CustomerUpdateProfile",
      resGetOTP: "Auth/ResidentialGetOTP",
      resVerifyOTP: "Auth/ResidentialVerifyOTP",
      resChangePhoneVerifyOTP: "Auth/ResidentialChangePhoneVerifyOTP",
      changeProfile: "Auth/changeProfile",
      changePassword: "Auth/changePassword"
    }),
    filesChange(files) {
      this.inputs.file = files;
    },
    handleCheckPhone(e) {
      if (!/\d/.test(e.key)) {
        e.preventDefault();
      }
      if (this.profile.IsPhoneVerified == false) {
        this.phone_verified = false;
        return;
      }

      if (this.phone != this.profile.Phone) {
        this.phone_verified = false;
      } else {
        this.phone_verified = true;
      }
    },
    handleCheckOTP(e) {
      if (!/\d/.test(e.key)) {
        e.preventDefault();
      }
    },
    handleGetProfile() {
      // residentail
      if (
        this.isResidential ||
        this.isEnterpriseAdmin ||
        this.isEnterpriseUser
      ) {
        this.getProfile()
          .then(res => {
            this.profile = res.data.Data[0];
            this.phone = this.profile.Phone;
            this.phone_verified = this.profile.IsPhoneVerified;
            this.phone_verified_org = this.profile.IsPhoneVerified;
          })
          .catch(err => {});
      }
    },
    handleGetOTP() {
      let regExp = /^0[1-9][0-9]{8}$/i;
      if (!regExp.test(this.phone)) {
        swal.fire({
          title: this.$t("errors.number.invalid_number_format"),
          text: "",
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("ok"),
          buttonsStyling: false
        });
        return;
      }

      this.resGetOTP({ phone: this.phone })
        .then(res => {
          this.timerCount = 60;
          this.refCode = "ref";
          this.otpCode = "";
        })
        .catch(err => {
          // check error casuse contain "block"
          let errorText = "";
          if (err.response.data.Cause.includes("block")) {
            errorText = this.$t("errors.request_over_5_times");
          }

          swal.fire({
            title: this.$t("errors.request_otp_fail"),
            text: errorText,
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: this.$t("ok"),
            buttonsStyling: false
          });
        });
    },
    handleVerifyOTP() {
      this.resChangePhoneVerifyOTP({
        phone: this.phone,
        OTP: this.otpCode
      })
        .then(res => {
          this.refCode = "";
          this.otpCode = "";
          this.profile.Phone = this.phone;
          let verify_text = "change_mobile_success";
          if (!this.phone_verified) {
            this.phone_verified = true;
            this.phone_verified_org = true;
            verify_text = "verify_mobile_success";
          }
          swal.fire({
            title: this.$t(verify_text),
            text: "",
            icon: "success",
            confirmButtonClass: "btn btn-primary btn-fill",
            confirmButtonText: this.$t("ok"),
            buttonsStyling: false
          });
        })
        .catch(err => {
          let error_text = "errors.change_mobile_failed";
          if (!this.phone_verified) {
            this.phone_verified = true;
            error_text = "verify_mobile_success";
          }
          swal.fire({
            title: this.$t(error_text),
            text: this.$t(err.response.data.Msg),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: this.$t("ok"),
            buttonsStyling: false
          });
        });
    },

    handleUpdateUpdate() {
      this.updateProfile({
        Name: this.profile.Name,
        LName: this.profile.LName
      })
        .then(resp => {
          swal
            .fire({
              title: this.$t("profile.change_profile_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              // Set Name
              this.$router.push({ name: "agent_number" });
            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t("errors.profile.change_profile_failed"),
            text: $t(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: this.$t("ok"),
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
